module.exports = __webpack_public_path__ + "img/des-4.d5b19152.jpg";